var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShowOnMap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_show_on_map"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 3L20.34 3.03L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38V20.5C3 20.78 3.22 21 3.5 21L3.66 20.97L9 18.9L15 21L20.339 19.2014C18.9803 17.5085 16 13.5092 16 11C16 8.4 18.2386 6 21 6V3.5C21 3.22 20.78 3 20.5 3ZM15 19L9 16.89V5L15 7.11V19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17C21 17 24 13.4 24 11.15C24 9.35 22.6569 8 21 8C19.3431 8 18 9.35 18 11.15C18 13.4 21 17 21 17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShowOnMap);
export default __webpack_public_path__ + "static/media/ic_show_on_map.af3641545472f7f74cba1b8afe7f26c6.svg";
export { ForwardRef as ReactComponent };